import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components";
import { editPassword } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSuccess } from "../../helpers/Toast";

const EditPassword = () => {
  const navigate = useNavigate();
  const [old_password, setold_password] = useState("");
  const [password, setpassword] = useState("");
  const [repeat_password, setrepeat_password] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== repeat_password) {
      showError("Password baru dan konfirmasi password tidak cocok");
      return;
    }

    const body = { old_password, password, repeat_password };

    try {
      setIsSubmitting(true);
      const response = await fetch(editPassword, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        showError(JSON.stringify(errorData.errors).replace(/["{}]/g, "").replace(/:/, ": "));
        return;
      }
      showSuccess("Password berhasil diperbarui");
      navigate("/profile");
    } catch (error) {
      showError("Gagal memperbarui password");
    } finally {
      setIsSubmitting(false);
    }
  };

  const PasswordInput = ({ label, value, onChange, show, onToggle, placeholder }) => (
    <div>
      <label className="block text-xs font-semibold text-gray-500 mb-1.5">{label}</label>
      <div className="relative">
        <input
          value={value}
          onChange={onChange}
          type={show ? "text" : "password"}
          placeholder={placeholder}
          required
          className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 pr-11 text-sm text-gray-800 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/30 transition"
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={onToggle}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          {show ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Ubah Password</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/profile" title="Ubah Password" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-4 space-y-4">
            <PasswordInput
              label="Password Lama"
              value={old_password}
              onChange={(e) => setold_password(e.target.value)}
              show={showOld}
              onToggle={() => setShowOld((v) => !v)}
              placeholder="Masukkan password lama"
            />
            <PasswordInput
              label="Password Baru"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              show={showNew}
              onToggle={() => setShowNew((v) => !v)}
              placeholder="Masukkan password baru"
            />
            <PasswordInput
              label="Konfirmasi Password Baru"
              value={repeat_password}
              onChange={(e) => setrepeat_password(e.target.value)}
              show={showRepeat}
              onToggle={() => setShowRepeat((v) => !v)}
              placeholder="Ulangi password baru"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex items-center justify-center gap-2 rounded-2xl py-3.5 text-sm font-bold text-white shadow-md transition active:scale-95 disabled:opacity-70"
            style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
          >
            {isSubmitting ? (
              <>
                <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Menyimpan...
              </>
            ) : "Simpan Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditPassword;
